import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
	FreudButtonModule,
	FreudCalendarModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { AppointmentDateTimeComponent } from './appointment-date-time.component';

@NgModule({
	declarations: [AppointmentDateTimeComponent],
	imports: [
		CommonModule,
		ReactiveFormsModule,
		FreudCalendarModule,
		TranslateModule,
		FormsModule,
		FreudButtonModule,
	],
	exports: [AppointmentDateTimeComponent],
})
export class AppointmentDateTimeModule {}
